import { useRouter } from "next/router";
import {
  isRegistrationPageContext,
  PageContext,
} from "./useDetailsPageContext";
import { addQueryParams, removeQueryParams } from "~lib/helpers/queryParams";

export type ModalType =
  | "releaseCodes"
  | "registration"
  | "registration-success"
  | undefined;

export function isValidModalType(modal: unknown): modal is ModalType {
  if (typeof modal !== "string") return false;

  return ["releaseCodes", "registration", "registration-success"].includes(
    modal
  );
}

export function useDetailsPageModalState(pageContext: PageContext) {
  const router = useRouter();

  const activeModal: ModalType | undefined = (() => {
    const modalQueryParam = router.query.modal;

    if (isValidModalType(modalQueryParam)) {
      // Don't show the registration modal if the page isn't in a registration state
      if (
        (modalQueryParam === "registration" ||
          modalQueryParam === "registration-success") &&
        !isRegistrationPageContext(pageContext)
      ) {
        return undefined;
      }

      return modalQueryParam;
    }

    return undefined;
  })();

  const setActiveModal = (modalType: ModalType | undefined) => {
    if (modalType) {
      addQueryParams(router, { modal: modalType });
    } else {
      removeQueryParams(router, ["modal"]);
    }
  };

  return {
    activeModal,
    setActiveModal,
  };
}
